import React, { FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { EditDialog, EditDialogProps } from '../EditDialog/EditDialog';

export type SingleTabEditDialogProps = Omit<
  EditDialogProps<'general'>,
  'activeTabName' | 'onTabSelected' | 'children'
> & {
  tabTitle: string;
};

/**
 * This is a wrapper for the EditDialog for usages which only need one tab, so you don't have to configure that much
 */
export const SingleTabEditDialog: FunctionComponent<SingleTabEditDialogProps> =
  React.memo((props) => {
    const { tabTitle, children, ...remainingProps } = prepareProps({ props });

    return (
      <EditDialog<'general'>
        {...remainingProps}
        activeTabName="general"
      >
        {() => ({
          general: {
            name: 'general',
            title: tabTitle,
            renderContent: () => children
          }
        })}
      </EditDialog>
    );
  });
